module.exports = function(s) {
  return s && (s.lopCount > 0 || (s.acGPA !== '' && s.acGPA < 2.00) || (s.citGPA !== '' && s.citGPA < 2.00) || s.library || s.finance);
}




// WEBPACK FOOTER //
// ./src/utilities/isOnLOP.js